export const CHINESE_TRANSLATIONS = {
  text: {
    web_title: 'SMARTZ™ 仪表板',
    authentication: '验证',
    username: '用户名',
    password: '密码',
    sign_in: '登录',
    username_required: '用户名为必需项',
    password_required: '密码为必需项',
    invalid_credential: '用户名或密码不正确',
    forgot_password: '忘记密码',
    change: '更改',
    well_being: '健康',
    warnings: '警告',
    no_patients_to_change: '没有要更改的患者',
    no_patients: '没有患者',
    logout: '退出登录',
    lost_connection: '与 Smartz™ 云的连接断开',
    check_connection: '请检查您的互联网连接',
    trying_to_reconnect: '正在尝试重新连接',
    pad_time: '尿垫时间',
    red_time: '红色时间',
    position: '姿势',
    time: '时间',
    time_in_position: '姿势时间',
    sitting: '坐姿',
    standing: '站姿',
    left: '左',
    right: '右',
    lying: '卧姿',
    unknown: '未知',
    wet_surface: '湿表面',
    out_of_range: '超出范围',
    low_battery: '电池电量低',
    disconnected: '已断开连接',
    unexpected_problem: '意外问题',
    ok: '确定',
    change_soon: '马上更换',
    change_pad: '更换尿垫',
    languages: '语言',
    dashboard: '仪表板',
    pad_fill_profile: '尿垫充液情况',
    goal: '目标',
    report: '报告',
    manage: '管理',
    individual: '个人',
    group: '群组',
    action_required: '需要行动',
    monitor: '监测',
    pod_unclipped: 'Pod 未夹持',
    check_patient: '检查患者',
    check_pad: '检查尿垫',
    check_time_in_pad: '检查尿垫时间',
    check_position: '检查姿势',
    check_temperture: '检查温度',
    check_pad_fill_profile: '检查尿垫充液情况',
    instructions: '说明',
    time_in_pos: '姿势时间',
    pad_capacity: '尿垫容量',
    time_in_pad: '尿垫时间',
    ambient: '环境',
    time_at_temp: '温度/时间',
    pad_wet: '尿垫湿',
    pad_dry: '尿垫干',
    daily_pad_fill: '每日尿垫充液',
    seven_day_trend: '七日趋势',
    daytime: '日间',
    nighttime: '夜间',
    volume_in_pad: '尿垫容量',
    pad_fill_summary: '尿垫充液摘要',
    daily_average: '日平均',
    today: '今天',
    capacity: '容量',
    pads_used: '已使用尿垫',
    per_day: '每天',
    average: '平均',
    leakage_detected: '已检测到泄漏',
    times: '次',
    pad_cycles: '尿垫周期',
    time_in_a_pos: '姿势时间',
    max_time_in_a_pos: '最长姿势时间',
    re_positioning: '改变姿势',
    time_day: '时间/日',
    temperature: '温度',
    typical_temp: '典型温度',
    temp_range: '温度范围',
    charts: '图表',
    pad_fill_profile_for_7_days: '尿垫充液情况 - 七天趋势',
    daily_total: '每日总计',
    accuracy: '准确度',
    last_24_hours: '从所选日期起 24 小时',
    volume_voided_in_pad: '尿垫上的排尿量',
    body: '身体',
    wetness_usage: '湿度/用量',
    environment_body: '周围温度',
    activity: '活动',
    lift_style: '抬举方式',
    skin_care: '皮肤照护',
    skin_care_management: '皮肤照护管理',
    workflow: '工作流程',
    workflow_efficiency: '工作流程效率',
    set_maximum_voiding_volume_into_pad: '设置尿垫的最大排尿量',
    less_void: '更少排尿',
    more_void: '更多排尿',
    day: '日',
    night: '夜',
    day_time: '日间',
    night_time: '夜间',
    average_period: '平均周期',
    default: '默认',
    desire_position: '姿势时间',
    time_in_a_position: '姿势时间',
    desire_temperature: 'Pod 周围温度',
    coloer: '较冷',
    hotter: '较热',
    desire_skin_care: '皮肤照护',
    off: '关',
    standard_care: '标准照护',
    extra_care: '额外照护',
    more_time_in_wet_pad: '更多时间在湿垫上',
    more_time_in_a_pos: '更多时间在一个姿势',
    less_time_in_wet_pad: '更少时间在湿垫上',
    less_time_in_a_pos: '更少时间在一个姿势',
    override: '这个目标将优先于尿垫和身体目标',
    check_pod: '检查 pod',
    check_pod_and_reclip: '检查 pod 并重新夹上',
    lost_connect: '连接断开',
    voids_into_pad_hours: '96 小时内尿垫上的排尿',
    chart_date: '图表日期',
    fullscreen: '全屏',
    normalscreen: '普通屏幕',
    void_chart: '排尿图表',
    voids_into_pad: '尿垫上的排尿',
    pad_fill_trend: '尿垫充液趋势',
    legend: '图例',
    new_pad: '新尿垫',
    void_in_pad: '尿垫中排尿',
    share: '共享',
    print: '打印',
    position_profile: '姿势情况',
    body_position: '身体姿势',
    body_positions_over_96_hours: '96 小时的身体姿势',
    lying_on_back: '卧姿 - 背朝下',
    lying_on_front: '卧姿 - 面朝下',
    lying_left_side: '卧姿 - 左侧卧',
    lying_right_side: '卧姿 - 右侧卧',
    standing_walking: '站立/行走',
    stats: '统计',
    pad_used: 'pad_used',
    max: '最高',
    surrounding_temperature: '周围温度',
    temp: '温度',
    avg: '平均',
    name: '名称',
    provider: '供应商',
    purpose: '目的',
    expiry: '到期',
    type: '类型',
    frequently_asked_questions: '常见问题',
    information_for_use: '使用信息',
    data_privacy: '数据隐私',
    eula: '最终用户许可协议',
    about: '关于',
    settings: '设置',
    save: '保存',
    version: '版本',
    support: '支持',
    close: '关闭',
    copyright: '版权所有 (C) 2022 Smartz Operations Limited.保留所有权利',
    smartz_devices: 'Smartz™ 设备',
    monitor_smartz_device_operation: '监控 Smartz™ 设备操作',
    last_seen: '上次扫描',
    battery: '电池',
    ago: '前',
    date_rate: '日使用量',
    online: '在线',
    singnal: '信号',
    temperature_goal: '温度目标',
    data_privacy_desc: '管理同意书和个人数据',
    organisation: '组织',
    organisation_desc: '管理群组设置',
    my_account: '我的帐户',
    my_account_desc: '管理帐户设置',
    consent: '同意书',
    marketing_comm: '营销、传播和促销',
    consent_desc:
      '尿垫制造商和分销商可能使用个人数据进行营销和促销。与此患者关联的用户帐户（如果有）可能会不时收到电子邮件。在这种情况下，可能会将用户的电子邮箱提供给第三方。',
    data_management: '数据管理',
    Permanently_delete_account: '永久删除此用户帐户',
    permanently_delete_client: '永久删除此客户',
    data_management_desc: '帐户将不再可用，并且帐户中的所有数据将被永久删除。',
    how_can_i_export: '如何导出和备份我的帐户数据？',
    save_preference: '保存首选项',
    delete_account_data: '删除帐户和数据',
    date_time_settings: '日期和时间设置',
    morning_time: '上午时间',
    night_time_label: '晚间时间',
    time_format: '时间格式',
    date_format: '日期格式',
    goal_text: '目标',
    day_goal: '日间目标',
    night_goal: '夜间目标',
    check_battery: '检查电池',
    reminders: '提醒',
    update_data_privacy_consent: '更新数据隐私同意书',
    update: '更新',
    user: '用户',
    last_updated: '上次更新',
    action: '操作',
    delete_confirm: '您确定要删除吗？',
    cancel: '取消',
    lost_internet_connection: '网络连接丢失',
    check_setting: '请检查您的互联网设置和连接',
    authentication_required: '需要验证',
    account_details_have_changed: '帐户详情已更改',
    date: '日期',
    no_pod_assigned: '未分配 Pod',
    monitoring_is_not: '由于尚未分配 Smartz™ Pod，监控不可用',
    assign_a_pod: '将 pod 配到',
    on_the_smartz_monitor_app: '（在 Smartz™ 监控应用上）以激活监控。',
    see: '参见',
    delete: '删除',
    keep_in_mind_delete_data: '请记住，删除用户帐户和个人数据是永久性操作。',
    you_able_to_delete_data: '您将要删除',
    account_and_data: '帐户和数据',
    this: '此',
    average_time_in_pad: '平均尿垫时间',
    average_time_in_position: '平均姿势时间',
    repositioning_24h: '24 小时体位变换',
    last_7_day_period: '过去 7 天期间',
    admin: '管理员',
    administraive_settings: '管理设置',
    group_data_rentenion: '群组数据保留',
    maximum_inactivity_data_retention_period: '最大非活动数据保留期',
    group_data_rentenion_desc:
      '如果已达到非活动期，则此群组内所有用户和患者的个人数据将被删除。',
    data_rentenion_detail:
      '非活动状态的情况如下：<br>- 在指定时间内未将 Pod 分配给患者<br>- 已将 Pod 分配给患者，但在指定的时间内没有向 Smartz™ 传输数据<br>- 在指定的时间内没有被分配的用户',
    months: '个月',
    user_roles: '用户角色',
    users: '用户',
    role: '角色',
    filter_by_group_or_users: '按群组或用户筛选',
    urine_conversion_feature: '尿液转换功能',
    use_urine_transform: '使用尿液转换',
    system_data_rentenion: '系统数据保留',
    system_data_rentenion_desc:
      '如果已达到非活动期限，则此系统内所有用户和患者的个人数据将被删除。',
    reset_password: '重置密码',
    new_password: '新密码',
    confirm_password: '确认密码',
    password_inconsistent: '密码不一致',
    edit: '编辑',
    edit_roles: '编辑角色',
    available_roles: '可用角色',
    assigned_roles: '所分配的角色',
    role_list: '角色列表',
    role_name: '角色名称',
    role_permissions: '角色权限',
    level_1_module: '1 级模块',
    level_2_module: '2 级模块',
    permissions: '权限',
    add_role: '添加角色',
    roles: '角色',
    role_settings: '角色设置',
    edit_role: '编辑角色',
    account_take_effect: '更新将在重新登录后生效。',
    algorithms: '算法',
    delete_role_confirm: '删除角色是永久性操作。',
    //translate permissions list
    'Dashboard Module': '仪表板模块',
    'Charts Module': '图表模块',
    'Goals Module': '目标模块',
    'Manage Module': '管理模块',
    Group: '群组',
    Individual: '个人',
    'Voiding Chart': '排尿图表',
    'Pad Fill Profile Chart': '尿垫充液情况图表',
    'Body Position Chart': '身体姿势图表',
    'Smartz Devices Chart': 'Smartz™ 设备图表',
    'Pad Fill Profile': '尿垫充液情况',
    'Skin Care': '皮肤照护',
    Position: '姿势',
    Temperature: '温度',
    Admin: '管理员',
    'My Account': '我的帐户',
    Role: '角色',
    Organisation: '组织',
    'Data Privacy': '数据隐私',
    View: '查看',
    Share: '共享',
    Print: '打印',
    Save: '保存',
    'Reset Password': '重置密码',
    Delete: '删除',
    Add: '添加',
    Edit: '编辑',
    Fall: '跌倒',
    //end translate permissions list
    check_fall: '检查跌倒',
    position_goal_not_allow_off:
      '当跌落目标打开时，位置目标不能关闭，以提高安全性。',
    falls: '跌倒',
    falls_detection_and_notification: '跌倒检测及通知',
    falls_detection: '跌倒检测',
    detect_falls: '检测跌倒',
    on: '开',
    position_goal: '姿势目标',
    has_been_turn_on: '已开启以补充跌倒检测并提高安全性。',
    last_fall: '上一次跌倒',
    last_week: '最近一周',
    three_months: '3 个月',
    time_to_change: '更换时间',
    sent_successfully: '发送成功',
    sent_failed: '发送失败',
    send_email: '发送电子邮件',
    send: '发送',
    add_email: '添加电子邮件',
    saved_successfully: '保存成功',
    saved_failed: '保存失败',
    deleted_successfully: '删除成功',
    deleted_failed: '删除失败',
    email: '电子邮箱',
    please_enter_email_address: '请输入电子邮件地址',
    please_enter_the_correct_email_address: '请输入正确的电子邮件地址！',
    time_in_a_pad_goal: '尿垫目标中的时间',
    time_goal: '时间目标',
    body_temperature: '体温',
    upper_goal_limit: '目标上限',
    lower_goal_limit: '目标下限',
    time_of_fall: '跌倒时间',
    heart_rate: '心率',
    max_heart_rate: '最大心率',
    min_heart_rate: '最小心率',
    average_heart_rate: '平均心率',
    oximetry: '血氧测定值',
    blood_o2_saturation: '血氧饱和度',
    min_oximetry: '最小血氧测定',
    max_oximetry: '最大血氧测定值',
    average_oximetry: '平均血氧量测定值',
    respiration: '呼吸',
    breathing_pattern: '呼吸方式',
    breath: '气息',
    respiration_vs_oximetry: '呼吸 vs 血氧测定',
    min_respiration: '最小呼吸',
    max_respiration: '最大呼吸',
    average_respiration: '平均呼吸',
    balance: '平衡',
    falls_and_balance: '跌倒和平衡',
    loss_of_balance_events: '失去平衡事件',
    sudden_changes_in_body_orientation: '身体方位感的突然改变',
    goal_limit: '目标极限',
    last_event_exceeding_goal: '超出目标的最后一个事件',
    balance_loss_events: '失去平衡事件',
    per_7_days: '每 7 天',
    body_lean_over_7_days: '7 天里的身躯前倾',
    chart_shows_tendency: '图表显示了身体在移动时朝特定方向倾斜的趋势',
    lean_forward: '前倾',
    backwards: '向后',
    forward: '向前',
    vitals: '生命体征',
    vitals_signs: '生命体征',
    spo2: '血氧',
    pulse: '脉搏',
    abdominal_movement: '腹部运动',
    min: '分钟',
    attach_the_pod:
      '仅当尿垫放在患者身上时才能连接 pod。如果不遵守本说明，可能会导致由于在尿垫被穿在患者身上之前的移动和调整而错误地检测到跌倒。',
    body_positions_analysis: '体位分析',
    repositioning: '体位变换',
    stayed_in_one_position: '保持在一个位置上',
    change_in_position: '位置变化',
    no_pod_data: '没有 pod 数据',
    possible_intervention: '可能的干预措施',
    body_position_goal: '身体姿势目标',
    tap_to_setup_body_position_goals: '轻触以设置身体姿势目标',
    time_blocks_greater_than: '时间段大于',
    will_be_highlighted: '将突出显示',
    chart_filters: '图表过滤器',
    tap_to_show: '轻触显示',
    tap_to_hide: '轻触隐藏',
    notifications: '通知',
    time_to_reposition: '变换体位前的时间',
    hour: '小时',
    hours: '小时',
    minute: '分钟',
    minutes: '分钟',
    sensor_disconnected: '传感器已断开',
    from: '自',
    to: '至',
    quick_start_guide: '快速入门指南',
    wet_outside: '垫外湿度',
    attend_fall: '注意跌倒',
    reclip_pod: '重新夹上 POD',
    change_position: '改变姿势',
    replace_battery: '更换电池',
    allowed_time_exceeded: '已超过容许时间',
    wetness_outside: '外部湿度',
    analysing_pad: '正在分析尿垫',
    pad_not_selected: '未选择尿垫',
    silence: '静音',
    silence_confirm_box_title: '静音跌倒',
    silence_confirm_box_content:
      '将跌倒通知静音会将其从群组仪表板中删除。是否要继续？',
    yes: '是',
    no: '否',
    pad_status: '尿垫状态',
    check_pad_fill: '检查尿垫',
    patient_profile: '患者情况',
    periods: '期间',
    products: '产品',
    active: '活动',
    manage_user_profile: '管理用户情况',
    sign_out: '退出登录',
    view: '查看',
    groups: '群组',
    groups_in_view: '视图中的群组',
    total_daily_profile: '每日总量',
    day_profile: '日间量',
    night_profile: '夜间量',
    pad_fill_profile_goal: '尿垫充液情况目标',
    tap_to_setup_pad_fill_profile_goals: '轻触以设置尿垫充液情况目标',
    insufficient_data: '数据不足',
    last_7_days: '最近 7 天',
    pad_removed: '已移除尿垫',
    view_groups: '查看群组',
    minimum_voiding_into_pad: '尿垫的最小排尿量',
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
    Sunday: '星期日',
    disconnected_desc: '等待 pod 重新夹到尿垫上……',
    pod_unclipped_desc: '等待 pod 返回到范围内……',
    password_policy: '密码策略',
    position_chart: '姿势图',
    hi_everyone: '大家好，',
    voiding_chart_email_content:
      '通过电子邮件发送的“排尿图表”已准备就绪，可供您查看。',
    pad_fill_profile_chart_email_content:
      '通过电子邮件发送的“尿垫充液情况图表”已准备就绪，可供您查看。',
    position_chart_email_content:
      '通过电子邮件发送的“姿势图表”已准备就绪，可供您查看。',
    temperature_chart_email_content:
      '通过电子邮件发送的“温度图表”已准备就绪，可供您查看。',
    heare_rate_chart_email_content:
      '通过电子邮件发送的“心率图表”已准备就绪，可供您查看。',
    oximtry_chart_email_content:
      '通过电子邮件发送的“血氧图表”已准备就绪，可供您查看。',
    respiration_chart_email_content:
      '通过电子邮件发送的“呼吸图表”已准备就绪，可供您查看。',
    balance_chart_email_content:
      '通过电子邮件发送的“平衡图表”已准备就绪，可供您查看。',
    smartz_chart_email_content:
      '通过电子邮件发送的“Smartz™ 图表”已准备就绪，可供您查看。',
    best_regards: '此致',
    the_simavita_team: 'Smartz 运营团队',
    days: '天',
    weeks: '周',
    years: '年',
    reset_all_users_passwords: '重置所有用户的密码',
    reset_all_passwords: '重置所有密码',
    reset: '重置',
    change_password: '更改密码',
    old_password: '旧密码',
    lowercase: '小写',
    uppdercase: '大写',
    number: '数字',
    please_select: '请选择',
    loading_chart: '正在加载图表',
    please_wait: '请稍候……',
    edit_user: '编辑用户',
    add_user: '添加用户',
    edit_group: '编辑群组',
    add_group: '添加群组',
    group_name: '群组名称',
    group_name_required: '群组名称为必填项',
    patients: '患者',
    manage_user_account: '管理用户帐户',
    filter_by_group_name: '按群组名称筛选',
    delete_group_warning: '请记住，删除群组是永久性操作。',
    delete_patient_warning: '删除患者和个人数据是永久性操作。',
    pod_mac: 'Pod Mac',
    pod_serial_number: 'Pod 序列号',
    add_patient: '添加患者',
    edit_patient: '编辑患者',
    alias: '别名',
    alias_required: '必须填写别名',
    pod_mac_required: 'Pod 为必需项',
    pod_serial_number_required: 'Pod 序列号为必需项',
    please_enter_capital_letters_and_numbers: '请输入大写字母和数字',
    select_date_range: '选择日期范围',
    start_time: '开始时间',
    end_time: '结束时间',
    select_groups_to_collate: '选择要整理的群组',
    all_groups: '所有群组',
    export_report: '导出报告',
    export_csv: '导出 CSV',
    reports: '报告',
    please_complete_form: '请填写表单',
    nodes: '节点',
    network_map: '网络地图',
    network_utilisation: '网络利用率',
    notify_me_when_nodes_offline: '当节点离线时通知我',
    zoom_in_chart: '在图表中启用缩放',
    latency: '延迟',
    lan: '局域网',
    wifi_infrastructure: 'Wi-Fi 基础设施',
    pods: 'Pod',
    data: '数据',
    packet_less: '数据包更少',
    secondary_connection: '辅助连接',
    rssi: 'RSSI',
    no_nodes: '无节点',
    share_code: '共享代码',
    //Start translation from here.
    active_patients: '活动患者',
    archived_patients: '已存档患者',
    archive: '存档',
    restore: '还原',
    are_you_sure: '您确定吗？',
    you_about_to_archive: `您将要存档`,
    default_group_not_delete: '无法删除默认群组',
    patients_belong_to: '患者归属',
    move: '移动',
    warning: '警告',
    add_node: '添加节点',
    edit_node: '编辑节点',
    room_name: '房间名称',
    mac_address: 'MAC 地址',
    delete_node_warning: '删除节点是永久性操作。',
    mac_address_required: 'MAC 地址为必需项',
    room_name_required: '房间名称为必需项',
    mac_address_format_warning:
      '输入的 MAC 地址格式不正确。请以 XX:XX:XX:XX:XX:XX:XX 格式输入',
    connection_type: '连接类型',
    device_role: '设备角色',
    device_type: '设备类型',
    offline: '离线',
    node_management: '节点管理',
    time_period: '时间段',
    manufacturer: '制造商',
    product: '产品',
    please_select_time_period: '请选择一个时间段',
    please_select_manufacturer: '请选择制造商',
    please_select_product: '请选择产品',
    no_data: '无数据',
    please_select_manufacturer_first: '请先选择制造商',
    details: '详细信息',
    time_period_warning: '日间时间段和夜间时间段需要覆盖一天的总时间段24小时。',
    reset_successfully: '重置成功',
    region: '地区',
    select_at_least_one_group: '至少选择一个群组',
    node: '节点',
    pods_location: 'Pod 位置',
    pod_id: 'Pod ID',
    accelerometer: '加速计',
    senser: '传感器',
    gain: '增益',
    offset: '偏移',
    failed_to_connecte_smartz_service: '无法连接到 Smartz<sup>®</sup> 服务',
    add_to_smartz_group_failed: '无法添加到 smartz 群组服务',
    retry: '重试',
    customization: '自定义',
    customization_settings: '自定义设置',
    colors: '颜色',
    font: '字体',
    logo: '徽标',
    login_background: '登录背景',
    apply: '应用',
    theme: '主题',
    to_current_site: '到当前站点',
    customize_theme_text: '自定义网站外观。想体验冒险？',
    create_a_custom_theme: '创建自定义主题',
    custom_theme: '自定义主题',
    preview: '预览',
    reset_customization_settings: '所有配置都已还原为默认值',
    drag_the_logo_here: '将徽标拖动到这里',
    or: '或',
    click_upload: '点击上传',
    only_image_files_can_be_uploaded: '只能上传 JPG/PNG 文件',
    the_size_of_the_uploaded_image_cannot_exceed: '上传图片的大小不能超过 2MB',
    please_sign_out_to_preveiw_effect: '上传后，请退出以预览效果',
    please_enter_theme_name: '请输入主题名称',
    failed: '失败',
    add_pod: '添加 Pod',
    edit_pod: '编辑 Pod',
    filter_pod: '按 pod mac 地址筛选',
    filter_node: '按节点、MAC 地址和房间筛选',
    delete_pod_warning: '删除节点是永久性操作。',
    delete_theme_warning: '删除主题是永久性操作。',
    apply_theme_warning:
      '注意：此操作会将把自定义设置应用于域名。请注意这一点。',
    please_enter_domain_name: '请输入域名',
    domain_name_incorrect: '域名格式不正确',
    apply_successfully: '应用成功',
    location: '位置',
    manufacturer_code: '制造商代码',
    node_mac_address: '节点 MAC 地址',
    expired: '已过期',
    please_select_location: '请选择位置',
    filter_patients: '筛选患者',
    monitor_patient: '监测患者',
    patient: '患者',
    room: '房间',
    assign: '分配',
    unassign: '取消分配',
    unassign_patient_permanent: '请记住，取消分配患者是永久性操作。',
    you_able_to_unassign: `您即将取消分配`,
    node_mac_address_required: '节点 mac 地址为必需项',
    not_assigned: '未分配',
    assign_node_to: '将节点分配至',
    create_user: '创建用户',
    email_is_required: '电子邮箱为必需项',
    created_successfully: '创建成功',
    manage_patient_data: '管理患者数据',
    selected_patient: '所选患者',
    archive_patient: '存档患者',
    archive_patient_warning:
      '存档患者数据。在还原之前，患者将不再出现在系统上。',
    archive_patient_data: '存档患者数据',
    restore_patient: '还原患者',
    restore_patient_warning: '还原存档数据，以便可在此系统上查看。',
    archive_date: '存档日期',
    restore_patient_data: '还原患者数据',
    delete_account: '删除帐户',
    user_accounts: '用户帐户',
    selected_site: '所选站点',
    no_site: '无站点',
    drag_the_login_background_here: '将登录背景拖动到此处',
    drag_the_menu_background_here: '将菜单背景拖动到此处',
    patient_data_privacy: '患者数据隐私',
    edit_theme: '编辑主题',
    drag_the_main_content_background_here: '将主要内容背景拖动到此处',
    opacity_desc: '透明度（在背景上悬浮内容的透明度）',
    menu_bg: '菜单背景',
    main_content_bg: '主要内容背景',
    background: '背景',
    account: '帐户',
    super_admin: '超级管理员',
    help: '帮助',
    filter_by_user_name: '按用户名筛选',
    drag_the_top_nav_background_here: '将顶部导航栏背景拖动到此处',
    apply_theme: '应用主题',
    apply_to_this_domain: '应用于此域',
    crop_image: '裁剪图像',
    enlarge: '放大',
    narrow: '缩窄',
    left_rotation: '向左旋转',
    right_rotation: '向右旋转',
    remove_image: '删除图像',
    operation_area: '操作区域',
    preview_area: '预览区域',
    logo_shape: '徽标形状',
    show_as_circle: '显示为圆圈',
    history: '历史',
    status: '状态',
    download: '下载',
    export: '导出',
    created_date: '创建日期',
    next: '下一个',
    register: '注册',
    back: '返回',
    create_an_organisation: '创建组织',
    please_enter_organisation_name: '请输入组织名称',
    address: '地址',
    please_enter_organisation_address: '请输入组织地址',
    phone: '电话',
    please_enter_organisation_phone: '请输入组织电话',
    description: '说明',
    add_facility: '添加设施',
    edit_facility: '编辑设施',
    facility: '设施',
    no_room: '没有房间',
    facility_name: '设施名称',
    add_room: '添加房间',
    room_already_exists: '房间已经存在',
    home: '主页',
    signed_into: '登录到',
    please_select_an_organisation: '请选择一个组织',
    hello: '您好',
    useful_features: '实用功能',
    attention: '注意',
    quick_actions: '快捷操作',
    no_patient_warning: '没有要监测的患者。立即添加患者以开始。',
    add_patient_quick_action_desc: '添加要监测的患者',
    welcome_to_the_group_dashboard: '欢迎使用群组仪表板',
    show_me_more: '显示更多',
    add: '添加',
    welcome_to_patient_management: '欢迎使用患者管理',
    update_patient: '更新患者',
    update_patient_quick_action_desc: `更新患者详细信息`,
    change_patient_products: `更换患者的产品`,
    change_patient_products_quick_action_desc: '更换患者使用的产品',
    reassign_pod_to_patient: '将 Pod 重新分配给患者',
    reassign_pod_quick_action_desc: `更换患者的 pod`,
    monitor_patient_with_a_node: '将节点分配至患者',
    monitor_patient_with_a_node_quick_action_desc: '查看患者的节点',
    welcome_to_the_administration_section: '欢迎使用管理员部分',
    invite_user: '邀请用户',
    invite_user_quick_action_desc: '邀请用户加入系统',
    remove_or_archive_patient: '删除/存档患者',
    remove_or_archive_patient_quick_action_desc: '从仪表板中删除患者',
    profile: '个人资料',
    not_monitored: '未监测',
    rounds: '轮次',
    //translate permissions list
    'Super Admin': '超级管理员',
    Algorithms: '算法',
    Customisation: '自定义',
    Account: '帐户',
    'Roles & Permissions': '角色和权限',
    'Network Map': '网络地图',
    'Network Utilisation': '网络利用率',
    'Buildings & Rooms': '设施和房间',
    Manufacturers: '制造商',
    Settings: '设置',
    Profile: '个人资料',
    Devices: '设备',
    Nodes: '节点',
    'Pods Location': 'Pod 位置',
    'Share Code': '共享代码',
    Users: '用户',
    'User Accounts': '用户帐户',
    'Invite User': '邀请用户',
    Patients: '患者',
    'Monitor Patient': '监测患者',
    'Patient Data Privacy': '患者数据隐私',
    Archive: '存档',
    Restore: '还原',
    'Patients Module': '患者模块',
    Export: '导出',
    History: '历史',
    Report: '报告',
    Monitor: '监测器',
    //translate permissions list
    time_zone: '时区',
    please_select_time_zone: '请选择时区',
    add_facility_and_room: '添加设施和房间',
    filter_by_facility_name: '按设施名称筛选',
    floor: '楼层',
    please_enter_facility_name: '请输入设施名称',
    please_enter_floor_name: '请输入楼层名称',
    please_enter_room_number: '请输入房间号',
    facility_name_already_exists: '设施名称已存在',
    floor_name_should_be_unique: '楼层名称应该是唯一的',
    room_number_should_be_unique: '房间号码应该是唯一的',
    add_manufacturer: '添加制造商',
    filter_by_manufacturer_code_or_name: '按制造商代码或名称筛选',
    enabled: '已启用',
    delete_manufacturer_warning: '删除制造商是永久性操作。',
    please_enter_role_name: '请输入角色名称',
    please_choose_one_as_the_current_organization: '请选择一个作为当前组织',
    display_name: '显示名称',
    assign_roles: '分配角色',
    remove: '删除',
    please_assign_a_role_to_the_user: '请为用户分配一个角色',
    send_invitation: '发送邀请',
    invitation_email_sent: '邀请电子邮件已发送。',
    facility_and_Floor_and_Room: '设施、楼层和房间',
    export_patient: '导出患者',
    export_patient_history_data: '导出患者历史数据',
    export_patient_data: '导出患者数据',
    export_report_success_text: `正在导出患者数据。您将在其可用时通过电子邮件收到通知。在“文件”选项卡上检查进度。 `,
    select_patients: '选择患者',
    export_in_progress: '导出进行中',
    continue: '继续',
    please_enter_patient_name: `请输入患者的姓名`,
    please_enter_patient_alias: `请输入患者的别名`,
    facility_and_room: '设施和房间',
    create_new: '新建',
    add_facility_and_floor_and_room: '设施、楼层和房间',
    select_facility_floor_room: '选择设施、楼层和房间',
    choose_one: '选择一个',
    enter_manually: '手动输入',
    pod_serial_number_format_incorrect: '输入的尿垫序列号格式不正确。',
    add_a_manufacturer_to_continue: '添加制造商以继续',
    please_enter_subscription_code: '请输入订阅代码',
    added_successfully: '添加成功',
    select_a_patient: '选择患者',
    assign_products: '分配产品',
    assign_pod: '分配 Pod',
    assign_node: '分配节点',
    we_have_created_a_default_facility:
      '我们为您所在的组织创建了默认的设施、楼层和房间',
    if_you_want_edit_this_facility: `如果您想编辑此设施的信息，请轻触`,
    or_you_can: '您也可以',
    already_registered: '已注册',
    sign_up: '注册',
    create_account: '创建帐户',
    pod_and_diaper: 'Pod 和尿布',
    pod_and_diaper_content: ` <p class="underline">按照以下步骤将 Pod 连接到尿布：</p>
          <ul>
            <li>
            将智能尿布上的三个条带与 Smart Pod 上的三个金色引脚对齐
            </li>
            <li>将 pod 夹在智能尿布的<span class="underline">正面</span></li>
            <li>
            绿灯快速闪烁 3 秒时间，然后常亮 1 秒 = 连接良好
            </li>
            <li>
            20 秒后无绿灯闪烁 = 无连接。松开夹子然后重新夹住 Smart Pod
            </li>
            <li>如果连接正确但没有灯光闪烁，说明电池没电</li>
          </ul>`,
    home_landing_slide1_title: '欢迎使用健康门户',
    home_landing_slide1_content: `
      <p>通过健康门户，您可以监测患者的失禁和健康状况。</p>
      <p>监测患者群组，以确定行动的优先次序，并提供以个人为中心的照护。</p>`,
    home_landing_slide2_title: '智能尿布技术',
    home_landing_slide2_content: `
      <p>当 Smart pod 连接到智能尿布时，其将通过网络传输数据，让照护者能够通过健康门户监测患者。</p>
      <p>当您的患者于系统中分配时，您将一目了然地知道何时更换尿布，还可查看历史数据。您还可以轻松设置目标，并收到通知，告诉您何时更换尿布、患者的姿势、监测液体排出、检查周围温度和潜在的跌倒。</p>`,
    home_landing_slide4_title: '添加第一位患者',
    home_landing_slide4_content: `
      <p>要开始，请使用“快捷操作”按钮添加患者，然后按照提示进行操作。</p>
      <p>在整个“患者”设置过程中，系统将为您提供协助。</p>`,
    home_landing_slide5_title: '快捷操作',
    home_landing_slide5_content: `
      <p>这些功能允许您访问“添加患者”一类的经常性操作。</p>
      <p>向导将引导您完成所需的所有步骤。 </p>`,
    dashboard_landing_slide1_title: '欢迎使用群组仪表板',
    dashboard_landing_slide1_content: `
      <p>在仪表板上监控您的所有患者，并知道您的患者何时需要照料。</p>
      <p>通过遵循系统视觉提示，可以减少您的工作量。</p>`,
    dashboard_landing_slide2_title: '欢迎使用群组仪表板',
    dashboard_landing_slide2_content: `<ul>
      <li>显示的图标用于指示患者的状态</li>
      <li>“仪表板”分为两个部分，分别是<span class="underline">需要行动</span>和<span class="underline">监测</span></li>
      <li>为了减少工作量并改善患者的照护，倾向于优先使用<span class="underline">“需要行动”</span>图标</li>
    </ul>`,
    dashboard_landing_slide3_title: '尿布状态',
    dashboard_landing_slide3_content: `
      <p>尿布状态和“更换时间”由红绿灯系统表示：</p>
      <ul>
        <li><span class="red-text"><span class="underline">红色</span> = 更换尿垫，</span>即湿尿布有漏尿风险</li>
        <li><span class="yellow-text"><span class="underline">黄色</span> = 准备更换尿布，</span>即尿布将要吸满</li>
        <li><span class="green-text"><span class="underline">绿色</span> = 无需操作，</span>即干燥尿布</li>
      </ul>`,
    dashboard_landing_slide4_title: '其他状态',
    dashboard_landing_slide4_content: `
      <p>为确保照护的连续性，请关注仪表板上显示的所有操作：</p>
      <ul>
        <li>“连接断开”符号表示蓝牙连接已断开，并且可能发生数据丢失。</li>
        <li>“改变姿势”符号表示到了改变患者姿势的时候了。</li>
      </ul>`,
    dashboard_landing_slide5_title: '优化',
    dashboard_landing_slide5_content: `<p>查看群组仪表板通知，以优化您的日常患者照护。</p>`,
    dashboard_landing_slide6_title: '区域筛选',
    dashboard_landing_slide6_content: `
      <p>区域筛选是一个可选功能，让您可以在设施的仪表板上查看所选区域。区域筛选功能需谨慎使用，因为这将将隐藏现有患者，并且仅显示筛选出的选择。</p>
      <p>要选择新的区域筛选条件： </p>
      <ol>
        <li>选择区域下拉列表</li>
        <li>轻触“新区域”</li>
        <li>输入“区域筛选条件名称”</li>
        <li>选择大楼</li>
        <li>勾选区域、楼层和房间编号</li>
        <li>在筛选条件摘要框中查看筛选条件选择</li>
        <li>轻触以保存此区域筛选条件</li>
        <li>从下拉菜单中选择区域筛选条件或“管理区域”</li>
      </ol>
    `,
    home_landing_slide3_title: 'Pod 和尿布',
    home_landing_slide3_content: `
    <ul>
      <li>将 pod 连接到尿布</li>
      <li>观察 pod 上的绿色 LED 灯</li>
      <li>接收患者状态的更新</li>
    </ul>`,
    patient_landing_slide1_title: '个人仪表板',
    patient_landing_slide1_content: `
      <p>选择单个患者时，新的仪表板将显示当前正在监测的所有功能的状态，包括正在使用的 Smart pod 和尿布。</p>
      <p>从下拉菜单中选择要显示的其他患者。</p>`,
    patient_landing_slide2_title: `欢迎使用“患者”部分`,
    patient_landing_slide2_content: `
      <p>“个人”仪表板显示患者的当前状态。</p>
      <p>“图表”部分记录健康趋势。</p>
      <p>具体目标可以在“目标”部分进行设置，并会收到通知。</p>`,
    patient_landing_slide3_title: '访问个人仪表板、图表和目标',
    patient_landing_slide3_content: `<p>在仪表板的左侧，您可以访问患者、图表和目标部分。</p>`,
    patient_landing_slide4_title: '患者/个人仪表板',
    patient_landing_slide4_content: `
      <ul>
        <li>每位患者都有属于自己的个人仪表板</li>
        <li>深入了解患者的个人状态</li>
        <li>通过在下拉箭头中选择，在患者之间切换</li>
      </ul>`,
    patient_landing_slide5_title: '图表',
    patient_landing_slide5_content: `
      <p>您可以使用各种图表查看和解释数据，包括：</p>
      <ul>
        <li>排尿图表</li>
        <li>尿垫充液情况</li>
        <li>姿势图表。</li>
      </ul>
      <p>您可以打印和分享这些内容，以查看和调整患者的照护。</p>`,
    patient_landing_slide6_title: '目标',
    patient_landing_slide6_content: `
      <p>为了进一步提高对您患者的照护，可以设置特定目标。这些目标包括：</p>
      <ul>
        <li>身体调位</li>
        <li>皮肤照护</li>
        <li>尿垫充液情况</li>
        <li>温度</li>
        <li>跌倒。</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>只需使用下拉菜单即可选择要查看的患者。</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>选择要显示的日期范围，最多可以显示7天。</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>排尿图表将提供您的患者排尿史的整体视图。</li>
        <li>使用 Smartz<sup>®</sup> 系统时，排尿图表上会显示实时数据。</li>
        <li>此图表让您可以在查看尿垫周期或排尿事件概览之间进行切换。</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>图标可以通过选择进行筛选。</li>
        <li>排尿图表下方的图例显示图表上所显示的图标。</li>
        <li>轻触“图表筛选”以选择或取消选择要查看的图标。</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>通过查看此图表，您能够：</p>
      <ul>
        <li>确定患者可以成功如厕的潜在时间</li>
        <li>尿布是否在可接受的时间段内更换</li>
        <li>期间的尿垫更换次数</li>
        <li>共享并打印您的图表。</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>事件图表会显示尿布、pod、目标和网络状态的所有事件。</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>“每日总量”显示在24小时内进入尿垫的排出液体总量。</li>
        <li>每日排入尿布中的总量显示在每个液滴上方。</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>右侧的图标表示所选几天期间排出的“平均”体积。</li>
        <li>切换以单独查看“日间”和“夜间”量。</li>
        <li>该图表显示是否已设置或触发填充尿垫充液情况目标。</li>
        <li>如果需要，选择以设置目标。</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>每日总量显示 24 小时内进入尿布的排出液体总量。</li>
        <li>如果患者的排尿量减少，这可能是水分增加的指标。</li>
        <li>共享和打印您的图表。</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>该图表显示在所选几天内处在特定身体姿势下的时间长短。</li>
        <li>要查看更多详细信息，请将鼠标悬停在图表上。</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>轻触“图表筛选”以选择或取消选择想要显示的姿势。</li>
        <li>该图表突出显示是否已设置“身体姿势”目标。</li>
        <li>轻触以设置目标。</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>如果您的患者容易发生皮肤破溃/压力损伤，通过设定目标，您将收到何时改变患者姿势的通知。</li>
        <li>当选择“打印”时，姿势和时间段将被列入其他详细信息。</li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>查看灯泡部分以了解更多详细信息。</li>
      </ul>`,
    body_position_goal_help_title: '身体调位目标',
    body_position_goal_slide1_content: `
      <ul>
        <li>通过设定目标，照护者将收到何时改变患者姿势的通知。</li>
        <li>如果您的患者容易出现皮肤破溃/压力损伤，请使用此目标。</li>
        <li>缩短在同一姿势的时间可以帮助缓解压力损伤。</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>只需使用下拉菜单即可选择要查看的患者。</li>
        <li>移动滑块以选择您希望患者在日间和/或夜间处于同一姿势的最长时间。</li>
        <li>轻触以保存目标。</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>您现在已经选择了患者处于一姿势的最长时间长度，您将在要改变姿势时在“需要行动”部分收到通知。</li>
      </ul>`,
    skin_management_goal_help_title: '皮肤管理目标',
    skin_management_goal_slide1_content: `
      <ul>
        <li>更频繁地更换尿布有助于保持患者皮肤干燥并减少皮肤刺激。</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>只需使用下拉菜单即可选择要查看的患者。</li>
        <li>移动滑块以选择您希望患者一块尿布最长兜多长时间。</li>
        <li>轻触以保存目标。</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>您现在将在要更换患者尿布时在“需要行动”部分中收到通知。</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Pod 周围温度',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>此目标允许您设置 pod 周围的最低/最高温度。</li>
        <li>如果您担心患者的体温波动，请设置此目标。</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>只需使用下拉菜单即可选择要查看的患者。</li>
        <li>若要收到 pod 周围温度任何变化的通知，请移动滑块以选择最低和最高温度。</li>
        <li>轻触以保存目标。</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>当 pod 周围的温度超出设定范围时，您将在“需要行动”部分收到通知。</li>
      </ul>`,
    pad_fill_profile_goal_help_title: '尿垫充液情况目标',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>如果您担心患者尿量较低，此目标可让您设置进入尿布中的最小/最大排尿量。</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>只需使用下拉菜单即可选择要查看的患者。</li>
        <li>移动滑块以选择日间和/或夜间的首选尿量。</li>
        <li>轻触以保存目标。</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>当患者排入尿布的尿量超过设定范围时，您将在“需要行动”部分收到通知。</li>
      </ul>`,
    fall_detection_goal_help_title: '跌倒检测目标',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>如果您的患者跌倒，此目标将通知您。</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>只需使用下拉菜单即可选择要查看的患者。</li>
        <li>将滑块移动到开启位置以激活目标。</li>
        <li>默认情况下，“姿势时间”已开启。</li>
        <li>轻触以保存目标。</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>如果发生跌倒，将在“需要行动”部分显示一个闪烁的图标。</li>
        <li>在“个人仪表板”中将跌倒静音，将会把该图标从主仪表板中删除。</li>
      </ul>`,
    voiding_chart_help_dialog_title: '使用排尿图表',
    pad_fill_profile_chart_help_dialog_title: '使用尿垫充液情况',
    position_chart_help_dialog_title: '使用身体姿势图表',
    pad_fill_profile_goal_help_dialog_title: '设置尿垫充液情况目标',
    skin_care_goal_help_dialog_title: '设置皮肤照护管理目标',
    position_goal_help_dialog_title: '设置身体调位目标',
    temperature_goal_help_dialog_title: '设置 Pod 周围温度目标',
    fall_detection_goal_help_dialog_title: '设置跌倒检测目标',
    invite_user_quick_action_desc_for_home_landing: '邀请照护提供者加入此组织',
    archived_successfully: '已成功存档',
    verification_passed: '验证通过',
    verification_failed: '验证失败',
    verify_error_msg_801:
      '您的邀请已过期或不再有效。如需请求其他邀请，请与组织管理员联系。',
    verify_error_msg_802:
      '您的邀请对此用户无效。如果您在此前接受此邀请以其他用户身份登录，请退出登录，然后重试。',
    verify_error_msg_803: '用户未找到。',
    verify_error_msg_804: '未找到任何邀请码。',
    verify_error_msg_805: '您在自己想要加入的组织已经是成员了。',
    verify_success_msg: '欢迎加入新组织。',
    verify_error_msg_not_sign_in: `请登录以加入此组织。<br/>如果您没有帐户，请先注册。`,
    verify_error_msg_620: '代码无效或已过期',
    verify_error_msg_622: `无法加入组织。邀请码对于此电子邮件地址无效。`,
    failed_to_get_chart_data: '无法发送图表数据。',
    filter: '筛选',
    please_select_facility_first: '请首先选择设施',
    areas: '区域',
    floors: '楼层(s)',
    new_area: '新区域',
    manage_areas: '管理区域',
    show_all_facilities: '显示所有设施',
    show_all_areas: '显示所有区域',
    new_area_filter: '新建区域筛选条件',
    area_filter_name: '区域筛选条件名称',
    area: '区域',
    please_enter_area_filter_name: '请输入区域筛选条件名称',
    please_select_facility: '请选择设施',
    please_select_floor_and_room: '请选择楼层和房间',
    please_select_organisation: '请选择组织',
    filter_summary: '筛选摘要',
    show_patients_from: '显示患者，来自',
    in: '在',
    and: '及',
    belonging_to: '属于',
    select_an_area: '选择一个区域',
    manage_area: '管理区域',
    please_select_area_filter: '请选择区域筛选条件',
    delete_area: '删除区域',
    keep_in_mind_delete_area: '删除区域是永久性操作。',
    facility_information: '设施信息',
    floor_information: '楼层信息',
    room_information: '房间信息',
    number_of_floors: '楼层数',
    please_enter_number_of_floors: '请输入楼层数',
    number_of_rooms: '房间数',
    please_enter_number_of_rooms: '请输入房间数。',
    add_floor: '添加楼层',
    remove_floor: '删除楼层',
    remove_room: '删除房间',
    select_area_warning: `不能同时选择区域和楼层。<br/>仅选择一个。`,
    manage_area_filter: '管理区域筛选条件',
    no_area: '没有区域',
    there_are_no_patient_to_manage: '没有要管理的患者。',
    default_themes: '默认主题',
    custom_themes: '自定义主题',
    background_color: '背景颜色',
    top_navigation_background_color: '顶部导航背景颜色',
    top_nav_text_color: '顶部导航文本颜色',
    top_nav_active_text_color: '顶部导航活动文本颜色',
    sidebar_background_color: '侧边栏背景颜色',
    sidebar_active_block_background_color: '侧边栏活动区块背景颜色',
    sidebar_text_color: '侧边栏文本颜色',
    sidbar_active_block_text_color: '侧边栏活动区块文本颜色',
    card_title_background_color: '卡片标题背景颜色',
    card_title_text_color: '卡片标题文本颜色',
    card_body_background_color: '卡片主体背景颜色',
    card_button_color: '卡片按钮颜色',
    room_number: '房间号',
    verify_invitation: '验证邀请',
    well_done: '干得不错！',
    you_have_updated_the_patient: `您已更新了患者的详细信息。`,
    you_have_created_the_patient: '您已添加了可在群组仪表板上查看的患者。',
    tell_me_more: '了解更多',
    registered_pods: '已注册 Pod',
    registered_nodes: '已注册节点',
    select: '选择',
    start: '开始',
    end: '结束',
    floor_name: '楼层名称',
    sign_in_failed: '登录失败',
    skin_care_goal_title: '尿垫时间',
    time_in_wet_pad: '湿{pad}中的时间',
    'Event Chart': 'Smartz 事件图表',
    account_information: '帐户信息',
    given_name: '名',
    surname: '姓',
    please_enter_pod_serial_number: '请输入 pod 序列号',
    manufacturer_subscription_code: `制造商订阅代码`,
    remove_node_mac_address: '删除节点 mac 地址',
    link_a_node_mac_address: '链接节点 mac 地址',
    export_data: '导出数据',
    available_files: '可用文件',
    export_patient_data_desc: '单击以下按钮导出历史数据：',
    dry_diaper: '干尿布',
    wet_diaper: '湿尿布',
    change_diaper: '更换尿布',
    external_humidity: '外部湿度',
    smartz_events: 'Smartz<sup>®</sup> 事件',
    smartz_events_chart_email_content:
      '通过电子邮件发送的“事件图表”已准备就绪，可供您查看。',
    reposition: '更换姿势',
    fall: '跌倒',
    cycle: '周期',
    pad_cycle: '尿垫周期',
    off_body: '离体',
    pad_status_legend: '尿垫状态',
    analysing_diaper_legend: '分析尿布',
    dry_wet_change_diaper: '干/湿/更换尿布',
    pod_status: 'Pod 状态',
    goal_status: '目标状态',
    diaper_removed_legend: '尿布已取下',
    time_to_change_legend: '需要更换的时间',
    out_of_range_legend: '超出范围',
    diaper_not_selected: '未选择尿布',
    duration: '持续时间',
    small_void: '少量排尿',
    medium_void: '中量排尿',
    large_void: '大量排尿',
    view_mode: '查看模式',
    voids_only: '仅排尿',
    void_event_size: '排尿事件大小',
    pad_start: '尿垫开始时间',
    pad_end: '尿垫结束时间',
    exceed_goal_time: '超出目标时间',
    reclip: '重新夹上',
    unstable_readings: '不稳定读数',
    not_selected: '未选择',
    analysing: '正在分析',
    create_organisation: '创建组织',
    all_times_are_in: '所有时间单位均为',
    failed_to_get_goal_settings: '获取目标设置失败',
    next_steps: '后续步骤',
    video: '视频',
    monitor_warning: '监测不可用，因为没有 Smartz<sup>®</sup> pod 被分配到',
    find_further_information: '如需查找更多信息，请见',
    here: '此处',
    savePatientPodErrMsg: `所提供的 pod 序列号在此组织内不存在。`,
    savePatientNodeErrMsg: `所提供的节点 mac 地址在此组织中不存在。`,
    already_registered_desc: '请使用您最初注册时的用户名和密码登录。',
    create_account_desc: '请提供用户名和密码以创建用户帐户以及用来访问网站。',
    signing_in: '登录中',
    signing_out: '正在退出',
    welcome: '欢迎',
    top: '顶部',
    facility_or_building: '设施/大楼',
    keep_at_least_one_facility: '至少保留一个设施',
    keep_at_least_one_floor: '至少保留一个楼层',
    keep_at_least_one_room: '至少保留一个房间',
    rename: '重命名',
    domain_name: '域名',
    subscription_code: '订阅代码',
    events: '事件',
    no_pods_text: '此组织中没有注册的 pod。',
    no_nodes_text: '此组织中没有注册的节点。',
    confirm_deletion: '确认刪除。',
    confirm_archive: '确认存档。',
    account_deletion: '帐户删除',
    delete_account_warning: '删除用户帐户和个人数据是永久性操作。',
    deletion: '删除',
    restoring_patient: '正在还原患者',
    font_family: '字体系列',
    font_size: '字体大小',
    font_color: '字体颜色',
    main_title: '主标题',
    title: '标题',
    small_title: '小标题',
    body_text: '正文文本',
    body_text_small: '正文文本（小）',
    supplementary_text: '补充文本',
    primary_text: '主要文本',
    regular_text: '常规文本',
    secondary_text: '次要文本',
    placeholder_text: '占位符文本',
    top_nav_background: '顶部导航背景',
    edit_facility_and_floor_and_room: '编辑设施、楼层和房间',
    please_select_buildings: '请选择大楼',
    please_select_floors: '请选择楼层',
    please_select_rooms: '请选择房间',
    facility_setup: '设施设置',
    apply_to_entered_domain: 'Apply to entered domain',
    view_a_patient_by_selecting_from_drop_down_menu:
      '通过从下拉菜单中选择来查看患者.',
    monitoring: '监测',
    silencing: '沉默',
    fall_detection: '坠落检测',
    pod: 'Pod',
    diaper: '尿布',
    time_in_diaper: '尿布时间',
    setup_area_filter_desc: '按照以下步骤设置新的区域过滤器.',
    max_time_in_pad: '最长尿垫时间',
    max_time_in_pos: '最长姿势时间',
    change_in: '内更换',
    not_monitoring: '未监测',
    exceed_allowed_time: '超过允许时间',
    exceed_predicted_time: '超出预计时间',
    Pseudonymized: '化名',
    Anonymized: '匿名',
    pseudonymized_permission_warning:
      '不能同时选择患者化名权限和患者编辑权限。请选择其中之一。',
    anonymized_permission_warning:
      '不能同时选择患者匿名权限和患者编辑权限。请选择其中之一。',
    please_select_one_product: '请选择日间产品或夜间产品之一',
    none: '无',
    invitation: '邀请函',
    has_invited: '已经邀请',
    to_join: '加入',
    invitation_desc: '如果您已有使用此电子邮件地址的帐户，请登录以加入。',
    if_not_please: '如果不，请',
    accept: '接受',
    decline: '拒绝',
    acceptable_temperature_range: '可接受温度范围',
    temperature_alert_off: '温度警报关闭',
    temperature_alert_on: '温度警报将启动如果温度',
    below: '低于',
    above: '超过',
    partial_body_repositioning: '部分身体重新定位',
    minimum_angle_change: '最小角度变化',
    degrees: '度',
    goal_time_exceed: '超过目标时间',
    allowed_time_exceed: '超过允许时间',
    predicted_time_exceed: '超过预计时间',
    safe_time_exceed: '超过安全时间',
    brief_not_used: '未使用尿垫',
    monitor_unstable_readings: '监测到不稳定的读数',
    leakage: '泄漏',
    new_battery: '新电池',
    exceed_safe_time_in_pad: '超过安全时间',
    predicted_change_time: '预计更换时间',
    total_time: '总时间',
    exceed_safe_time: '超过安全时间',
    consider_using_smartz_product: '考虑使用 smartz 产品',
    non_smartz_product_in_use: '未使用 smartz 产品',
    product_not_selected: '未选择产品',
    assign_smartz_product_to_patient: '将 smartz 产品分配给患者',
    wait_a_moment: '稍等...',
    find_patient: '找病人',
    life: '寿命',
    flat_battery: '电池电量不足',
    compliance_notifications: '合规通知',
    receive_email_notifications: '接收有关系统使用和合规性的电子邮件通知',
    example: '例如',
    receive_email_desc1: '如果不及时更换 Pod 电池，可能会导致无法监测患者',
    receive_email_desc2: '当护理人员未实现合规目标时',
    i_want_to_receive_these_notifications: '我想收到这些通知',
    subscribe_successfully: '订阅成功',
    unsubscribe_successfully: '取消订阅',
    voltage: '电压',
    generate: '生成',
    generate_report: '生成报告',
    period: '时期',
    baseline: '基线',
    trial: '试用',
    generate_in_progress: '生成中',
    generate_desc: `报告数据导出正在进行中。 当可用时，您将通过电子邮件收到通知。 在历史菜单上检查进度。`,
    report_history: '报告历史记录',
    double_tap: '双击',
    time_period_inconsistent_warning: '周期1和周期2的时间跨度要一致',
    trial_reports: '试用报告',
    'Trial Reports': '试用报告',
    Generate: '生成',
    resend_code: '重新发送',
    verification_required: '需要验证',
    security_step_up: '安全措施加强',
    security_step_up_desc: '由于您的安全级别升级，我们现在正在验证您的登录信息',
    we_have_sent_mfa_code_first_line: `我们已将 6 位数字的安全代码发送到您的电子邮件地址`,
    we_have_sent_mfa_code_second_line: `这个额外的步骤表明确实是您`,
    enter_secure_code: '输入安全代码',
    trust_this_browser: '信任这个浏览器',
    trust_browser_first_line:
      '如果您信任此计算机上的浏览器，下次登录时将不会要求您进行两步身份验证',
    trust_browser_second_line:
      '使用公共或共享计算机时，您永远不应该“信任浏览器”，我们建议您仅信任您经常使用的浏览器',
    not_now: '现在不要',
    browser_can_not_be_trust:
      '在私有模式下浏览器不能被信任。 选择“不再”继续登录',
    Observation: '观察',
    observation: '观察',
    common_area: '公共区域',
    qr_code: '二维码',
    please_enter_patient_alias_to_search: '请输入患者别名进行搜索',
    smartz_observations: '智能观察',
    scan_this_code_to_record_and_observation: '扫码记录观察',
    need_help: 'Need help',
    scan_this_code_to_learn_about_smartz: '扫描此二维码了解Smartz',
    summary: '摘要',
    incontinent_event_frquency: '失禁事件频率',
    bladder_daily: '膀胱（每天）',
    weekly: '每周',
    bowel_daily: '肠道（每日）',
    diaper_utilisation: '尿布使用',
    day_pad: '白天垫',
    usage: '使用',
    units_during_day: '单位（白天）',
    average_fill: '平均填充',
    night_pad: '夜间垫',
    unit_at_night: '单位（夜间）',
    averaxe_fill: '平均填充',
    Period: '时段',
    Observations: '观察',
    No_Observations: '无观察',
    data_quality: '数据质量',
    pod_out_of_range: 'Pod超出范围',
    Assessment: '评估',
    Day: '白天',
    inco_assessment: '失禁评估',
    bladder_chart: '膀胱图表',
    week: '周',
    count: '数量',
    inco_assessment_email_content:
      '通过电子邮件发送的Inco评估图表已准备好供您审阅。',
    observation_chart: '观察图表',
    inco_observation_chart_content:
      '已准备好通过电子邮件发送的观察表供您审查。',
    product_name: '产品名称',
    total_void: '总空置',
    utilisation: '利用率',
    node_network_error_msg:
      '由于与您设施中的Smartz Node网络失去连接，暂时无法更新仪表板。请联系您的IT支持团队',
    'Inco Assessment': '失禁评估',
    'Observation Chart': `观察图表`,
    reporting: '报告',
    reporting_page_desc: '以下关于您的组织的信息将用于报告',
    baseline_trial_periods: '基线/试验期',
    rounds_shifts: '轮次/班次',
    to_access_reports_go_to: '要访问报告，请转到',
    portal: '门户',
    you_are_about_to_remove_this_item: '您即将删除此项',
    add_round: '添加轮次/班次',
    edit_round: '编辑轮次/班次',
    poster_qr_code: '海报二维码',
    smartz_id_card: 'Smartz身份证',
    card_qr_code: '卡片二维码',
    id_card: '身份证',
    'Privacy Mode': '隐私模式',
    bed_number: '床位号',
    please_input_bed_number: '请输入床位号',
    range: '范围',
    please_enter_name: '请输入名称',
    please_select_range: '请选择范围',
    core_breakup: '核裂变',
    body_repositioning: '身体调位',
    Dashboard: '仪表盘',
    Organisations: '组织',
    RolesPermission: '角色权限',
    Network: '网络',
    Void: '排尿',
    BodyPosition: '身体姿势',
    Event: '事件',
    FillProfile: '填写资料',
    SkinCare: '护肤',
    Charts: '图表',
    Goals: '目标',
    Node: '节点',
    Pod: 'Pod',
    Reports: '报告',
    Invite: '邀请',
    Private: '私有',
    'Inco-assessment': '不确定性评估',
    application_link_key: '应用链接密钥',
    application_link_key_desc: `这是与您的组织关联的密钥。`,
    remove_application_link_key_desc: `如果您不想关联此密钥，可以删除它，或者您可以`,
    generate_a_new_one: '生成一个新的',
    generate_new_application_link_key_warning:
      '新生成的密钥将覆盖先前的链接密钥',
    delete_application_link_key_warning: `您即将删除此应用链接密钥`,
    copied_to_clipboard: '已复制到剪贴板',
    failed_to_copy: '复制失败',
    template: '模板',
    please_select_a_template: '请选择一个模板',
    choose_permission_template_desc:
      '从以下模板角色中选择一个以自动填充权限。然后，您可以根据您的具体要求自定义权限',
    Interoperability: '互操作性',
    comment: '评论',
    please_enter_comment: '请填写评论',
    filter_by_organisation_name: '按组织名称过滤',
    physical_activity_chart: '身体活动图表',
    stationary: '静止',
    sit_stand: '坐/站',
    walk: '步行',
    jog: '慢跑',
    run: '跑步',
    physical_activity_chart_content: '发送的身体活动图表已准备好供您查阅。',
    PhysicalActivity: '身体活动',
    bed_number_is_not_available: '床号不可用',
    show_archived_patients: '显示已归档的患者',
    archived: '已存档',
    create_facility: '创建设施',
    create_new_organisation: '创建一个新组织',
    add_role_title: '添加角色',
    create_new_role: '创建新角色',
    create_new_manufacturer: '创建新制造商',
    create_a_secondary_user: '添加辅助用户',
    please_enter_password: '请输入密码',
    please_enter_password_again: '请再次输入密码',
    password_rule: '密码必须包含大写字母、小写字母、数字和特殊字符。',
    password_length_rule: '密码必须为 8 到 12 个字符。',
    reset_password_successful: '重置密码成功',
    invited_user_list: '邀请用户列表',
    basic_settings: '基本设置',
    language: '语言',
    date_time_format: '日期时间格式',
    measure_unit: '计量单位',
    custom_system_terms: '自定义系统术语',
    custom: '自定义',
    singular: '单数',
    plural: '复数',
    term: '术语',
    pad_term_not_select_warning: '请选择垫术语或输入自定义术语',
    patient_term_not_select_warning: '请选择患者术语或输入自定义术语',
    register_an_installation_id: '注册安装ID',
    register_an_installation_id_desc:
      '将组织注册到一个网络，其中包含节点和 Pod 列表',
    installation_id: '安装ID',
    please_enter_installation_id: '请输入安装ID',
    register_an_installation_id_successful: '注册安装ID成功',
    your_organization_is_already_linked_site: '您的组织已链接到',
    you_can: '您可以',
    add_a_different_installation_id: '添加不同的安装ID',
    remove_this_installation_id: '移除此安装ID',
    your_organization_is_not_link_organisation:
      '您的组织尚未链接到 Smartz Node 网络，请',
    add_installation_id_desc:
      '添加安装ID将把此组织链接到 Smartz Node 网络。这将使该组织能够访问该网络中所有可用的节点和 Pods。',
    link_another_installation_id_warning:
      '请注意，这将断开与以前的 Smartz Node 网络的链接，并创建一个新的链接。某些属于旧安装ID的节点和 Pods 可能不可用。',
    remove_installation_id_warning:
      '请注意，这将断开与以前的 Smartz Node 网络的链接。属于当前安装ID的节点和 Pods 可能不可用。',
    remove_successful: '移除成功',
    add_lora_network: '添加 LoRa 网络',
    add_a_lora_network: '添加 LoRa 网络',
    add_a_different_lora_network: '添加不同的 LoRa 网络',
    remove_this_lora_network: '移除此 LoRa 网络',
    application_id: '应用 ID',
    please_enter_application_id: '请输入应用 ID',
    add_lora_network_successful: '添加 LoRa 网络成功',
    your_organization_is_already_linked_lora_network:
      '您的组织已链接到 LoRa 网络',
    your_organization_is_not_link_lora_network:
      '您的组织尚未链接到 LoRa 网络，请',
    add_lora_network_desc:
      '添加 LoRa 网络将把此组织链接到 LoRa 网络。这将使该组织能够访问该网络中的所有 LoRa 设备。',
    link_another_lora_network_warning:
      '请注意，这将中断与之前的 LoRa 网络的链接并创建一个新的。某些曾是旧版 LoRa 网络一部分的设备可能不可用。',
    remove_lora_network_warning:
      '请注意，这将中断与 LoRa 网络的链接。曾是当前 LoRa 网络一部分的设备可能不可用。',
    'Dashboard Type': '仪表板类型',
    Carer: '护理人员',
    moodle_training: 'Moodle培训',
    care_plus_dashboard: 'Care Plus 仪表盘',
    take_action: '采取行动',
    task_completion_time: '任务完成时间',
    too_early: '太早',
    too_late: '太晚',
    ontime: '准时',
    great_work: '做得好',
    pad_change_desc: '{patientAlias} 在 {time} 前被更换',
    battery_change_desc: '{patientAlias} 的电池在 {time} 前被更换',
    position_change_desc: '{patientAlias} 的位置在 {time} 前被更改',
    fall_event_desc: '{patientAlias} 的跌倒在 {time} 前被处理',
    days_unit: '天',
    hours_unit: '小时',
    minutes_unit: '分钟',
    team_work: '团队合作',
    your_care_team_is_doing_great: '您的护理团队表现出色',
    a_few_things_to_improve_on: '需要改进的一些事项以取得成功',
    improve_early_change_desc:
      '仅因系统警报、大便、设定目标或泄漏更换 {pad}。避免常规更换。',
    improve_change_response_time_desc:
      '定期检查仪表板，一旦图标变红，立即更换 {pads}。',
    improve_goal_response_time_desc:
      '一旦“采取行动”部分显示目标图标，请立即照顾 {patient}。',
    improve_incorrect_clipping_desc:
      '检查 pod 和 {pad} 是否有缺陷。在夹紧之前将 pod 与条纹对齐，并注意闪烁的绿灯。请参考培训应用程序的说明。',
    improve_battery_change_desc:
      '一旦在仪表板或 pod 上显示电池更换提示，请立即更换电池。',
    improve_leakage_desc:
      '当图标变红时，立即更换 {pad}。检查 {pad} 的尺寸或 {pad} 的应用情况。',
    improve_frequent_lost_connection_desc:
      '避免丢失或丢弃 pod。将 pod 固定在新的 {pad} 上，并确保 {patient} 在覆盖范围内。',
    low: '低',
    medium: '中',
    high: '高',
    improve_offline_nodes_desc: `您的网络中有多个节点当前处于离线状态。请恢复这些节点，以确保系统正常运行。`,
    team_support: '团队支持',
    team_support_desc1: '可能的护理质量下降！',
    team_support_desc2: '需要改进',
    team_support_desc3: '可以做得更好',
    team_support_desc4: '还差一点',
    team_support_desc5: '还不错，但可以更好',
    team_support_desc6: '展现出潜力',
    team_support_desc7: '有潜力',
    team_support_desc8: '做得很好，争取做到完美！',
    team_support_desc9: '努力显著',
    team_support_desc10: '令人印象深刻',
    team_support_desc11: '优秀，不要停下来！',
    team_support_desc12: '太棒了，继续加油！',
    team_support_desc13: '惊人的努力！不要停下来',
    team_support_desc14: '杰出，继续保持！',
    team_support_desc15: '出色，继续保持！',
    insufficient_data_warning:
      '数据不足，无法提供反馈。等待完成 {count} 个垫圈循环',
    demo_org_desc: '该组织将用于演示目的',
    overall_evaluation: '总体评价',
    demonstration_mode: '演示模式',
    responsiveness: '响应能力',
    predicted_red: '预测红色',
    predicted_mode: '预测模式',
    predicted_time: '预计时间',
    display_time_in_dashboard: '在仪表板上显示时间',
    nurse_call_dashboard: '护士呼叫仪表板',
    organisation_code: '组织代码',
    generate_new: '生成新的',
    check_bin: '检查垃圾桶',
    filter_module_selection_background_color: '筛选模块选中背景色',
    filter_module_selection_text_color: '筛选模块选中文字颜色',
    filter_module_label_color: '筛选模块标签颜色',
    quick_action_icon_color: '快捷操作图标颜色',
    padding: '内边距',
    bottom: '底部',
    other: '其他',
    peel_and_apply: '撕开并贴上',
    calibration_in_progress: '校准进行中',
    apply_sensor: '应用传感器',
    apply_sensor_desc: '正在等待传感器应用',
    record_pod_change: '记录Pod变更',
    pod_change_history: 'Pod变更历史',
    change_date: '变更日期',
    reason: '原因',
    loggged_in_date: '登录日期',
    check_connection_status: '检查连接',
    check_connection_desc: '正在等待 Pod 连接...',
    checking_connection: '检查连接',
    max_sensor: '最大传感器',
    loosely_connected_reclip_pod: '松动连接 - 重新夹上 POD',
    loosely_connected: '松动连接',
    sensor: '传感器',
    embedded: '嵌入式',
    p_n_a: 'PnA',
    change_reason: '变更原因',
    please_select_change_reason: '请选择变更原因',
    feedback: '反馈',
    pad_weight: '{pad} 重量',
    export_pad_cycle_description: '点击下方按钮以导出 {pad} 周期数据',
    pad_weight_data_saved: '{pad}重量数据已保存：',
    pad_capacity_reached: '{pad}容量已达到',
    actual_weight: '实际重量',
    not_provided: '未提供',
    pad_weight_first_question: '这个 {pad} 是否已经满到需要更换了？',
    pad_weight_second_question: '您是否有实际的尿垫重量？',
    actual_weight_provided: '已提供实际重量',
    leakages: '泄漏',
    max_time_in_wet_pad: '湿{pad}最长时间'
  },
  country: 'China',
  language: '中文',
  abb_name: 'zh'
}
